<template>
  <v-container fluid>
    <ValidationObserver ref="observer" v-slot="{ invalid }">
      <v-form>
        <v-card>
          <v-card-title>
            <v-title>Edit Wholesaler Contact Info</v-title>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs6>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="wholesaleName"
                  rules="required"
                >
                  <v-text-field
                    name="wholesaleName"
                    label="Wholesale Name"
                    id="wholesaleName"
                    v-model="tempValue.wholesaleName"
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
              <v-flex xs6>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="email"
                  rules="required"
                  ><v-text-field
                    name="email"
                    label="Wholesaler Email"
                    :error-messages="errors"
                    id="email"
                    v-model="tempValue.email"
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
              <v-flex xs6>
                <ValidationProvider v-slot="{ errors }" name="bcc" rules=""
                  ><v-text-field
                    name="bcc"
                    label="Bcc"
                    :error-messages="errors"
                    id="bcc"
                    v-model="tempValue.bcc"
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" :disabled="invalid" @click.native="save"
              >Save</v-btn
            >

            <v-btn color="light-grey" @click.native="$emit('closed')"
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </ValidationObserver>
  </v-container>
</template>

<script>
import { HTTP } from "@/http-common";

export default {
  name: "WholesaleDetail",
  props: {
    wholesaler: { type: Object, required: true },
  },
  data() {
    return {
      tempValue: {},
    };
  },
  methods: {
    save() {
      let vm = this;
      HTTP.post("oms/UpdateWholesalerContacts", this.tempValue)
        .then((data) => {
          vm.$emit("saved", data.data);
        })
        .catch((err) => {});
    },
  },
};
</script>

<style scoped>
</style>